/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Assignment Time Field
 *
 * @file AssignmentTimeField.jsx
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import TimeTextField from '../common/TimeTextField';
import Icon from '../icons/Icon';

const AssignmentTimeField = ({
  name,
  control,
  label,
  rules,
  onAfterChange
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field, fieldState }) => (
      <TimeTextField
        className="assignment-form-time-field"
        label={label}
        value={field.value}
        onChange={(event) => {
          field.onChange(event.target.value);
          onAfterChange?.(event.target.value);
        }}
        parentApp="aet"
        icons={{ clock: <Icon name="ClockIcon" /> }}
        hasError={Boolean(fieldState.error)}
      />
    )}
  />
);

AssignmentTimeField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  rules: PropTypes.object,
  onAfterChange: PropTypes.func
};

AssignmentTimeField.defaultProps = {
  rules: undefined,
  onAfterChange: null
};

export default AssignmentTimeField;
